import angular = require('angular');
import { RetailerService } from '../api/retailer.service';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { IPaginationFilter } from '../../../app.common/modules/common/models';
import { StoreLoyaltyProgramPagingResult, StoreLoyaltyProgram } from '../core';
import _ = require('underscore');

export interface IThreshold {
    value: number;
    title: string;
}

export class LoyaltyProgramService {
    static $inject = ['http', 'retailerService'];
    thresholds: IThreshold[] = [];

    constructor(
        private http: HttpService,
        private retailerService: RetailerService

    ) { }

    getStoreLoyaltyPrograms(filter: IPaginationFilter) {
        return this.http.get<StoreLoyaltyProgramPagingResult>(this.retailerService.loyaltyPrograms(), { params: filter });
    }

    updateStoreLoyaltyProgram(id: number, model: StoreLoyaltyProgram) {
        return this.http.put<void>(this.retailerService.loyaltyPrograms(id), model);
    }

    getThresholds = async () => {
        if (!this.thresholds || _.isEmpty(this.thresholds)) {
            let thresholds = await this.http.get<number[]>(this.retailerService.loyaltyProgramsThresholds());
            this.thresholds = _.map(thresholds, this.getClientThreshold);
        }
        return this.thresholds;
    }

    getClientThreshold(threshold: number) {
        if (threshold) {
            return <IThreshold>{
                value: threshold,
                title: `${threshold * 100} %`
            };
        } else {
            return null;
        }
    }

    getCountryAndCurrency(): any {
        return this.http.get(this.retailerService.country()).then((country: any) => {
            return country;
        });
    }
}

angular
    .module('naut')
    .service('loyaltyProgramService', LoyaltyProgramService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/loyaltyProgram/loyaltyProgram.service.ts